"use client"

import Link from "next/link"
import Image from "next/image"
import { Button } from "@/components/ui/button"
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet"
import { Menu } from "lucide-react"
import { UserMenu } from "@/components/user-menu"
import { useAuth } from "@/contexts/AuthContext"

export function Header() {
  const { isAuthenticated, user, logout } = useAuth()

  return (
    <header className="fixed top-0 left-0 right-0 flex h-20 w-full items-center px-4 md:px-8 bg-white shadow-sm z-50">
      <Link href="/" className="flex items-center gap-2 text-lg font-semibold md:text-base">
        <Image 
          src="/LogoChiquito.png" 
          alt="Raime Rentals Logo" 
          width={40} 
          height={40}
          className="h-12 w-auto object-contain"
        />
      </Link>
      <nav className="ml-auto hidden md:flex gap-8 items-center">
        <Link href="/" className="text-base font-medium text-gray-700 hover:text-raime-golden-brown transition-colors">
          Inicio
        </Link>
        <Link
          href="#features"
          className="text-base font-medium text-gray-700 hover:text-raime-golden-brown transition-colors"
        >
          Ventajas
        </Link>
        <Link
          href="/propiedades"
          className="text-base font-medium text-gray-700 hover:text-raime-golden-brown transition-colors"
        >
          Propiedades
        </Link>
        <Link
          href="#contact"
          className="text-base font-medium text-gray-700 hover:text-raime-golden-brown transition-colors"
        >
          Contacto
        </Link>
        {isAuthenticated && <UserMenu />}
      </nav>
      <Sheet>
        <SheetTrigger asChild>
          <Button variant="outline" size="icon" className="ml-auto md:hidden bg-transparent border-none">
            <Menu className="h-6 w-6 text-raime-dark-blue" />
            <span className="sr-only">Toggle navigation menu</span>
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="bg-white">
          <Link href="/" className="flex items-center gap-2 text-lg font-semibold mb-6">
            <Image 
              src="/LogoChiquito.png" 
              alt="Raime Rentals Logo" 
              width={40} 
              height={82}
              className="h-16 w-auto object-contain"
            />
          </Link>
          <div className="grid gap-4 py-6">
            <Link
              href="/"
              className="flex w-full items-center py-2 text-lg font-semibold text-gray-800 hover:text-raime-golden-brown"
            >
              Inicio
            </Link>
            <Link
              href="#features"
              className="flex w-full items-center py-2 text-lg font-semibold text-gray-800 hover:text-raime-golden-brown"
            >
              Ventajas
            </Link>
            <Link
              href="/propiedades"
              className="flex w-full items-center py-2 text-lg font-semibold text-gray-800 hover:text-raime-golden-brown"
            >
              Propiedades
            </Link>
            <Link
              href="#contact"
              className="flex w-full items-center py-2 text-lg font-semibold text-gray-800 hover:text-raime-golden-brown"
            >
              Contacto
            </Link>
            {isAuthenticated && user && (
              <>
                <div className="border-t border-gray-200 my-2"></div>
                <div className="flex items-center gap-2 py-2">
                  <div className="flex items-center gap-2">
                    <div className="h-8 w-8 rounded-full bg-raime-golden-brown text-white flex items-center justify-center text-sm font-semibold">
                      {user.name?.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2)}
                    </div>
                    <div className="flex flex-col">
                      <p className="text-sm font-medium text-gray-800">{user.name}</p>
                      <p className="text-xs text-gray-600">{user.email}</p>
                    </div>
                  </div>
                </div>
                <Link
                  href="/admin"
                  className="flex w-full items-center py-2 text-lg font-semibold text-gray-800 hover:text-raime-golden-brown"
                >
                  Panel de Admin
                </Link>
                <button
                  onClick={() => {
                    logout()
                    window.location.href = "/"
                  }}
                  className="flex w-full items-center py-2 text-lg font-semibold text-red-600 hover:text-red-700"
                >
                  Cerrar Sesión
                </button>
              </>
            )}
          </div>
        </SheetContent>
      </Sheet>
    </header>
  )
}
